import { useCurrentId } from 'features/messaging/hooks'

import store from '../../../../redux/store'
import { api } from '../../api'
import { selectors } from '../../utils/selectors'

export function useRead() {
	const id = useCurrentId()

	const [readMutation] = api.useMarkReadMutation()

	return () => {
		const state = store.getState()

		const conversation = selectors.conversations.selectById(state, id)

		if (conversation.unread_count) {
			readMutation({ id, mark: true })
		}
	}
}
